<div class="d-flex flex-row">
    <input
        #timerInput
        [disabled]="disabled"
        class="timer-input text-end"
        type="text"
        (focus)="timerInput.select()"
        (keyup)="keyup()"
        (change)="onChangeTimer(timerInput.value, beskrivelseInput.value)"
        [value]="timer | time"
    />
    <span class="d-inline-block" [ngbTooltip]="beskrivelse || ''">
        <input
            #beskrivelseInput
            [disabled]="timerInput.value === '' || +timerInput.value === 0 || timerInput.value === '0:00' || disabled"
            class="beskrivelse-input"
            type="text"
            maxlength="255"
            (focus)="beskrivelseInput.select()"
            (change)="onChangeBeskrivelse(beskrivelseInput.value)"
            [value]="beskrivelse || ''"
        />
    </span>
</div>
